var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
import { deleteDataFomCollection, updateDataFromCollection } from './utils';
const initialState = {
    data: [],
    loading: false,
    count: 0,
    error: null,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const createDynamicApprovalValue = createAsyncThunk('reduxDynamicApprovalValues/create', (values_1, _a) => __awaiter(void 0, [values_1, _a], void 0, function* (values, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.dynamicApprovalValues.collection.create(values);
        return fulfillWithValue(response);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const updateDynamicApprovalValue = createAsyncThunk('reduxDynamicApprovalValues/update', (values_1, _a) => __awaiter(void 0, [values_1, _a], void 0, function* (values, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.dynamicApprovalValues.collection.update(values);
        return fulfillWithValue(response);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const deleteDynamicApprovalValue = createAsyncThunk('reduxDynamicApprovalValues/delete', (ids_1, _a) => __awaiter(void 0, [ids_1, _a], void 0, function* (ids, { fulfillWithValue, rejectWithValue }) {
    try {
        yield api.dynamicApprovalValues.collection.delete(ids);
        return fulfillWithValue(ids);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const dynamicApprovalValuePushTo = createAsyncThunk('reduxDynamicApprovalValues/pushTo', (value_1, _a) => __awaiter(void 0, [value_1, _a], void 0, function* (value, { fulfillWithValue, rejectWithValue }) {
    try {
        const response = yield api.pushTo(value);
        return fulfillWithValue(response.results);
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const createUpdateAndDeleteDynamicApprovalValue = createAsyncThunk('reduxDynamicApprovalValues/createUpdateAndDelete', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ toCreate, toUpdate, toDelete, }, { fulfillWithValue, rejectWithValue }) {
    try {
        const dynamicApprovalValueToCreate = toCreate.length && api.dynamicApprovalValues.collection.create(toCreate);
        const dynamicApprovalValueToUpdate = toUpdate.length && api.dynamicApprovalValues.collection.update(toUpdate);
        const dynamicApprovalValueToDelete = toDelete.length && api.dynamicApprovalValues.collection.delete(toDelete);
        const [toCreaterResponse, toUpdateResponse] = yield Promise.all([
            dynamicApprovalValueToCreate,
            dynamicApprovalValueToUpdate,
            dynamicApprovalValueToDelete,
        ]);
        return fulfillWithValue({ toCreate: toCreaterResponse || [], toUpdate: toUpdateResponse || [], toDelete });
    }
    catch (error) {
        return rejectWithValue(error);
    }
}));
export const createUpdateAndDeleteDynamicApprovalValueAction = createUpdateAndDeleteDynamicApprovalValue.fulfilled;
const { actions, reducer } = createSlice({
    name: 'reduxDynamicApprovalValues',
    initialState,
    reducers: {
        setAllDynamicApprovalValues: (state, { payload }) => {
            state.data = payload;
        },
        createDynamicApprovalValueFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const t = [...state.data, updatedPayload];
            const newData = removeDuplicates(t, (value) => value.id);
            state.data = newData;
        },
        updateDynamicApprovalValueFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const newData = state.data.map((asset) => {
                if (asset.id === updatedPayload.id) {
                    return Object.assign(Object.assign({}, asset), updatedPayload);
                }
                return asset;
            });
            state.data = newData;
        },
        deleteDynamicApprovalValueFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const newData = [...state.data].filter((value) => value.id !== updatedPayload.id);
            state.data = newData;
        },
    },
    extraReducers: (builder) => {
        // CREATE
        builder.addCase(createDynamicApprovalValue.pending, () => { });
        builder.addCase(createDynamicApprovalValue.fulfilled, (state, { payload }) => {
            state.data = [...state.data, ...payload];
        });
        builder.addCase(createDynamicApprovalValue.rejected, (state, { payload }) => {
            state.error = payload;
        });
        // UPDATE
        builder.addCase(updateDynamicApprovalValue.pending, () => { });
        builder.addCase(updateDynamicApprovalValue.fulfilled, (state, { payload }) => {
            const newData = updateDataFromCollection(state.data, payload);
            state.data = newData;
        });
        builder.addCase(updateDynamicApprovalValue.rejected, (state, { payload }) => {
            state.error = payload;
        });
        // DELETE
        builder.addCase(deleteDynamicApprovalValue.pending, () => { });
        builder.addCase(deleteDynamicApprovalValue.fulfilled, (state, { payload }) => {
            const idsArr = payload.map((el) => el.id);
            const newData = deleteDataFomCollection(state.data, idsArr);
            state.data = newData;
        });
        builder.addCase(deleteDynamicApprovalValue.rejected, (state, { payload }) => {
            state.error = payload;
        });
        // PUSH TO
        builder.addCase(dynamicApprovalValuePushTo.pending, () => { });
        builder.addCase(dynamicApprovalValuePushTo.fulfilled, (state, { payload }) => {
            const newData = updateDataFromCollection(state.data, payload);
            state.data = newData;
        });
        builder.addCase(dynamicApprovalValuePushTo.rejected, (state, { payload }) => {
            state.error = payload;
        });
        // CREATE, UPDATE AND DELETE
        builder.addCase(createUpdateAndDeleteDynamicApprovalValue.pending, () => { });
        builder.addCase(createUpdateAndDeleteDynamicApprovalValueAction, (state, { payload }) => {
            const { toCreate, toUpdate, toDelete } = payload;
            const stateWithCreatedData = [...state.data, ...toCreate];
            const stateWithUpatedData = updateDataFromCollection(stateWithCreatedData, toUpdate);
            const idsArr = toDelete.map((el) => el.id);
            const newData = deleteDataFomCollection(stateWithUpatedData, idsArr);
            state.data = newData;
        });
        builder.addCase(createUpdateAndDeleteDynamicApprovalValue.rejected, (state, { payload }) => {
            state.error = payload;
        });
    },
});
export const { setAllDynamicApprovalValues, createDynamicApprovalValueFromWS, updateDynamicApprovalValueFromWS, deleteDynamicApprovalValueFromWS, } = actions;
export default reducer;
